/* eslint-disable multiline-ternary */
import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';
import GlobalFilter from './GlobalFilter';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';

const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    title: {
        flex: '1 1 100%'
    }
}));

const TableToolbar = props => {
    const classes = useToolbarStyles();
    const {
        numSelected,
        preGlobalFilteredRows,
        setGlobalFilter,
        globalFilter,
        setModalTagsOpen,
        setModalNamesOpen,
        setModalOrdersOpen
    } = props;

    const init = {};

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0
            })}
        >
            <div style={{
                display: 'inline-block',
                width: '100%'
            }}>
                <div style={{
                    display: 'inline-block',
                    marginLeft: '30%'
                }}>
                    <GlobalFilter
                        preGlobalFilteredRows={preGlobalFilteredRows}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                    />
                </div>

                <div style={{
                    display: 'inline-block'
                }}>

                    <Tooltip title='Add'>
                        <IconButton aria-label='add' onClick={setModalTagsOpen || setModalNamesOpen || setModalOrdersOpen} initialValues={init} style={{
                            backgroundColor: '#002143',
                            border: 'none',
                            color: 'white',
                            padding: '7px',
                            textAlign: 'center',
                            textDecoration: 'none',
                            display: 'inline-block',
                            fontSize: '16px',
                            margin: '4px 2px',
                            marginTop: '2px'
                        }}>
                            <AddIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>

        </Toolbar>
    );
};
export default TableToolbar;
